// import React, { useContext, useEffect, useRef, useState } from "react";
// import gsap from "gsap";
// import Button from "@mui/material/Button";
// import image from "../Images/1-3.jpg";
// import LuxuryInfoSection from "./LuxuryInfoSection";
// import { ModalContact } from "./ModalContact";
// import { LanguageContext } from "./LanguageContext"; // ✅ جلب اللغة

// const HeroSection = () => {
//   const { language } = useContext(LanguageContext); // ✅ استخدام اللغة الحالية

//   const headingRef = useRef(null);
//   const paragraphRef = useRef(null);
//   const buttonRef = useRef(null);
//   const toastRef = useRef(null);
//   const backgroundRef = useRef(null);

//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     const originalOverflowX = document.body.style.overflowX;
//     document.body.style.overflowX = "hidden";

//     gsap.fromTo(
//       backgroundRef.current,
//       { opacity: 0, scale: 1.2 },
//       {
//         opacity: 1,
//         scale: 1,
//         duration: 1.5,
//         ease: "power2.out",
//         onComplete: () => {
//           document.body.style.overflowX = originalOverflowX;
//         },
//       }
//     );

//     const tl = gsap.timeline();

//     tl.fromTo(
//       headingRef.current,
//       { opacity: 0, y: 50 },
//       { opacity: 1, y: 0, duration: 1, ease: "power3.out" }
//     )
//       .fromTo(
//         paragraphRef.current,
//         { opacity: 0, y: 30 },
//         { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
//         "-=0.5"
//       )
//       .fromTo(
//         buttonRef.current,
//         { opacity: 0, scale: 0.8 },
//         { opacity: 1, scale: 1, duration: 0.6, ease: "back.out(1.7)" },
//         "-=0.3"
//       );

//     const isMobile = window.innerWidth <= 768;

//     if (isMobile) {
//       gsap.fromTo(
//         toastRef.current,
//         { y: 100, opacity: 0 },
//         { y: 0, opacity: 1, duration: 0.8, ease: "power3.out" }
//       );
//       const timeout = setTimeout(() => {
//         gsap.to(toastRef.current, {
//           y: 100,
//           opacity: 0,
//           duration: 0.8,
//           ease: "power3.in",
//         });
//       }, 5000);
//       return () => clearTimeout(timeout);
//     } else {
//       gsap.fromTo(
//         toastRef.current,
//         { x: 300, opacity: 0 },
//         { x: 0, opacity: 1, duration: 0.8, ease: "power3.out" }
//       );
//       const timeout = setTimeout(() => {
//         gsap.to(toastRef.current, {
//           x: 300,
//           opacity: 0,
//           duration: 0.8,
//           ease: "power3.in",
//         });
//       }, 3000);
//       return () => clearTimeout(timeout);
//     }
//   }, []);

//   // ✅ النصوص حسب اللغة
//   const texts = {
//     en: {
//       heading: "Luxury Masar 3 Villas in Sharjah",
//       paragraph: "Discover your dream villa with world-class amenities and prime location.",
//       button: "Know More",
//     },
//     ar: {
//       heading: "فلل مسار 3 الفاخرة في الشارقة",
//       paragraph: "اكتشف فيلتك الحلم مع مرافق عالمية وموقع متميز.",
//       button: "اعرف أكثر",
//     },
//   };

//   return (
//     <section
//       ref={backgroundRef}
//       className="position-relative d-flex align-items-center justify-content-center vh-100 text-center text-white"
//       style={{
//         backgroundImage: `url(${image})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       {/* Overlay */}
//       <div
//         className="position-absolute top-0 start-0 w-100 h-100"
//         style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
//       ></div>

//       {/* Content */}
//       <div className="position-relative container">
//         <h1 ref={headingRef} className="fw-bold display-4 mb-4">
//           {texts[language].heading}
//         </h1>
//         <p ref={paragraphRef} className="lead mb-5">
//           {texts[language].paragraph}
//         </p>
//         <Button
//           ref={buttonRef}
//           variant="contained"
//           color="warning"
//           size="large"
//           sx={{
//             fontWeight: "bold",
//             px: 4,
//             py: 1.5,
//             "&:hover": { backgroundColor: "#ffb300" },
//           }}
//           onClick={(e) => {
//             e.preventDefault();
//             setShowModal(true);
//           }}
//         >
//           {texts[language].button}
//         </Button>
//         <ModalContact open={showModal} onClose={() => setShowModal(false)} />
//       </div>
//     </section>
//   );
// };

// export default HeroSection;



























import React, { useContext, useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Button from "@mui/material/Button";
import image from "../Images/1-3.jpg";
import { ModalContact } from "./ModalContact";
import { LanguageContext } from "./LanguageContext";

gsap.registerPlugin(ScrollTrigger);

// ========== Falling Leaves Canvas ==========
const FallingLeaves = () => {
  const canvasRef    = useRef(null);
  const animFrameRef = useRef(null);
  const leavesRef    = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx    = canvas.getContext("2d");

    const resize = () => {
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const colors = [
      "#4a7c3f", "#5a9e4a", "#3d6b35", "#6aad55",
      "#8B6914", "#a07830", "#c49a3c", "#7a5c1e",
      "#6b8e3f", "#9db85a",
    ];

    function shadeColor(hex, amount) {
      const num = parseInt(hex.replace("#", ""), 16);
      const r   = Math.max(0, Math.min(255, (num >> 16)         + amount));
      const g   = Math.max(0, Math.min(255, ((num >> 8) & 0xff) + amount));
      const b   = Math.max(0, Math.min(255, (num & 0xff)        + amount));
      return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
    }

    const drawLeaf = (ctx, leaf) => {
      ctx.save();
      ctx.translate(leaf.x, leaf.y);
      ctx.rotate(leaf.rotation);
      ctx.scale(leaf.scaleX, leaf.scaleY);

      const s = leaf.size;
      ctx.beginPath();
      ctx.moveTo(0, -s);
      ctx.bezierCurveTo( s * 0.6, -s * 0.5,  s * 0.8,  s * 0.3, 0,  s);
      ctx.bezierCurveTo(-s * 0.8,  s * 0.3, -s * 0.6, -s * 0.5, 0, -s);
      ctx.closePath();

      const grad = ctx.createLinearGradient(-s * 0.5, -s, s * 0.5, s);
      grad.addColorStop(0,   leaf.color     + "ee");
      grad.addColorStop(0.5, leaf.color     + "cc");
      grad.addColorStop(1,   leaf.colorDark + "99");
      ctx.fillStyle = grad;
      ctx.fill();

      // عرق رئيسي
      ctx.beginPath();
      ctx.moveTo(0, -s);
      ctx.quadraticCurveTo(s * 0.1, 0, 0, s);
      ctx.strokeStyle = leaf.colorDark + "88";
      ctx.lineWidth   = s * 0.06;
      ctx.stroke();

      // عروق جانبية
      for (let i = -1; i <= 1; i += 0.5) {
        const py = i * s * 0.4;
        ctx.beginPath();
        ctx.moveTo(0, py);
        ctx.quadraticCurveTo( s * 0.4, py - s * 0.1,  s * 0.55, py);
        ctx.strokeStyle = leaf.colorDark + "44";
        ctx.lineWidth   = s * 0.03;
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, py);
        ctx.quadraticCurveTo(-s * 0.4, py - s * 0.1, -s * 0.55, py);
        ctx.stroke();
      }

      ctx.restore();
    };

    const GROUND_Y = () => canvas.height - 18;

    const createLeaf = (startFromTop = true) => {
      const color = colors[Math.floor(Math.random() * colors.length)];
      return {
        x:            Math.random() * canvas.width,
        y:            startFromTop
                        ? -30 - Math.random() * 120
                        : Math.random() * canvas.height,
        size:         10 + Math.random() * 18,
        speedY:       0.6 + Math.random() * 1.2,
        speedX:       (Math.random() - 0.5) * 0.8,
        rotation:     Math.random() * Math.PI * 2,
        rotSpeed:     (Math.random() - 0.5) * 0.04,
        scaleX:       1,
        scaleY:       1,
        scaleDir:     Math.random() > 0.5 ? 1 : -1,
        scaleSpeed:   0.01 + Math.random() * 0.02,
        swingAmp:     0.3  + Math.random() * 0.5,
        swingSpeed:   0.01 + Math.random() * 0.02,
        swingOffset:  Math.random() * Math.PI * 2,
        color,
        colorDark:    shadeColor(color, -40),
        opacity:      0.75 + Math.random() * 0.25,
        time:         0,
        state:        "falling",
        restTimer:    0,
        restDuration: 180 + Math.floor(Math.random() * 300),
      };
    };

    // ابدأ بـ 20 ورقة موزعة على الشاشة
    leavesRef.current = Array.from({ length: 20 }, () => createLeaf(false));

    let frameCount = 0;

    const animate = () => {
      animFrameRef.current = requestAnimationFrame(animate);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      frameCount++;

      // ورقة جديدة كل ~1.5 ثانية بلا توقف
      if (frameCount % 90 === 0) {
        leavesRef.current.push(createLeaf(true));
      }

      leavesRef.current = leavesRef.current.filter((leaf) => {
        leaf.time++;
        const ground = GROUND_Y();

        if (leaf.state === "falling") {
          leaf.y        += leaf.speedY;
          leaf.x        += leaf.speedX + Math.sin(leaf.time * leaf.swingSpeed + leaf.swingOffset) * leaf.swingAmp;
          leaf.rotation += leaf.rotSpeed;

          // 3D flip
          leaf.scaleX += leaf.scaleDir * leaf.scaleSpeed;
          if (Math.abs(leaf.scaleX) >= 1) leaf.scaleDir *= -1;

          // تباطؤ قبل الأرض
          if (leaf.y > ground - 80) {
            const t       = Math.max(0, (leaf.y - (ground - 80)) / 80);
            leaf.speedY   = Math.max(0.05, leaf.speedY  * (1 - t * 0.05));
            leaf.speedX  *= 0.98;
            leaf.rotSpeed *= 0.97;
          }

          // وصلت الأرض
          if (leaf.y >= ground) {
            leaf.y        = ground;
            leaf.speedY   = 0;
            leaf.speedX   = 0;
            leaf.rotSpeed = 0;
            leaf.state    = "resting";
          }

        } else if (leaf.state === "resting") {
          leaf.restTimer++;
          if (leaf.restTimer >= leaf.restDuration) {
            leaf.state = "fading";
          }

        } else if (leaf.state === "fading") {
          leaf.opacity -= 0.008;
          if (leaf.opacity <= 0) return false;
        }

        ctx.globalAlpha = Math.max(0, leaf.opacity);
        drawLeaf(ctx, leaf);
        ctx.globalAlpha = 1;

        return true;
      });
    };

    animate();

    return () => {
      cancelAnimationFrame(animFrameRef.current);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position:      "absolute",
        inset:         0,
        zIndex:        3,
        pointerEvents: "none",
      }}
    />
  );
};

// ========== Country codes (searchable by dial code or name) ==========
const COUNTRIES = [
  { iso: "AE", dial: "971", flag: "🇦🇪", en: "United Arab Emirates", ar: "الإمارات" },
  { iso: "SA", dial: "966", flag: "🇸🇦", en: "Saudi Arabia",         ar: "السعودية" },
  { iso: "EG", dial: "20",  flag: "🇪🇬", en: "Egypt",                ar: "مصر" },
  { iso: "KW", dial: "965", flag: "🇰🇼", en: "Kuwait",               ar: "الكويت" },
  { iso: "QA", dial: "974", flag: "🇶🇦", en: "Qatar",                ar: "قطر" },
  { iso: "BH", dial: "973", flag: "🇧🇭", en: "Bahrain",              ar: "البحرين" },
  { iso: "OM", dial: "968", flag: "🇴🇲", en: "Oman",                 ar: "عُمان" },
  { iso: "JO", dial: "962", flag: "🇯🇴", en: "Jordan",               ar: "الأردن" },
  { iso: "LB", dial: "961", flag: "🇱🇧", en: "Lebanon",              ar: "لبنان" },
  { iso: "IQ", dial: "964", flag: "🇮🇶", en: "Iraq",                 ar: "العراق" },
  { iso: "SY", dial: "963", flag: "🇸🇾", en: "Syria",                ar: "سوريا" },
  { iso: "YE", dial: "967", flag: "🇾🇪", en: "Yemen",                ar: "اليمن" },
  { iso: "PS", dial: "970", flag: "🇵🇸", en: "Palestine",            ar: "فلسطين" },
  { iso: "SD", dial: "249", flag: "🇸🇩", en: "Sudan",                ar: "السودان" },
  { iso: "LY", dial: "218", flag: "🇱🇾", en: "Libya",                ar: "ليبيا" },
  { iso: "TN", dial: "216", flag: "🇹🇳", en: "Tunisia",              ar: "تونس" },
  { iso: "DZ", dial: "213", flag: "🇩🇿", en: "Algeria",              ar: "الجزائر" },
  { iso: "MA", dial: "212", flag: "🇲🇦", en: "Morocco",              ar: "المغرب" },
  { iso: "TR", dial: "90",  flag: "🇹🇷", en: "Turkey",               ar: "تركيا" },
  { iso: "IN", dial: "91",  flag: "🇮🇳", en: "India",                ar: "الهند" },
  { iso: "PK", dial: "92",  flag: "🇵🇰", en: "Pakistan",             ar: "باكستان" },
  { iso: "GB", dial: "44",  flag: "🇬🇧", en: "United Kingdom",       ar: "بريطانيا" },
  { iso: "US", dial: "1",   flag: "🇺🇸", en: "United States",        ar: "أمريكا" },
  { iso: "FR", dial: "33",  flag: "🇫🇷", en: "France",               ar: "فرنسا" },
  { iso: "DE", dial: "49",  flag: "🇩🇪", en: "Germany",              ar: "ألمانيا" },
];

// ✅ نفس الـ API URL المستخدم في ModalContact
const LEAD_API_URL =
  "https://homewalkers.realatixcrm.com/api/v1/users/create-with-params" +
  "?addedby=68da45a5b37ddfab3b73bd8b" +
  "&stage=68d110bbad5a0732ad44e5cf" +
  "&Channal=6a48bfa6a4cf5854ad69d511" +
  "&project=68e36f383b0e6ff7d205ded6" +
  "&salesdata=68da75b5b37ddfab3b7463f5" +
  "&Communicationway=69159308820816f4ad71c3bf" +
  "&campaignid=69ca62736bc129db99a826fb" +
  "&includePhone2=false" +
  "&includeWhatsapp=false" +
  "&includeJobDesc=false" +
  "&includeQuestion1=false" +
  "&includeQuestion2=false" +
  "&includeQuestion3=false" +
  "&includeQuestion4=false" +
  "&includeQuestion5=false" +
  "&campaignRedirectLink=https%3A%2F%2Fmassar3-d09ef.web.app%2F";

// ========== Phone Capture Widget (country code + phone + send) ==========
const PhoneCaptureWidget = ({ language }) => {
  const isRTL = language === "ar";

  const [selectedCountry, setSelectedCountry] = useState(
    COUNTRIES.find((c) => c.iso === "AE")
  );
  const [phone, setPhone]           = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [search, setSearch]         = useState("");
  const [status, setStatus]         = useState(null); // null | "sending" | "sent" | "error"

  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setDropdownOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredCountries = COUNTRIES.filter((c) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return (
      c.dial.includes(q) ||
      c.en.toLowerCase().includes(q) ||
      c.ar.includes(search.trim())
    );
  });

  const texts = {
    en: {
      placeholder: "Enter your phone number",
      send:        "Send",
      searchPh:    "Search country or code",
      sent:        "Sent successfully",
      error:       "Something went wrong, try again",
      invalid:     "Please enter your phone number",
    },
    ar: {
      placeholder: "ادخل رقم الهاتف الخاص بك",
      send:        "إرسال",
      searchPh:    "ابحث بالدولة أو الكود",
      sent:        "تم الإرسال بنجاح",
      error:       "حدث خطأ، حاول مرة أخرى",
      invalid:     "من فضلك ادخل رقم الهاتف",
    },
  };
  const t = texts[language];

  const handleSend = async () => {
    const cleanPhone = phone.replace(/\D/g, "");
    if (!cleanPhone) {
      setStatus("invalid");
      setTimeout(() => setStatus(null), 2500);
      return;
    }

    const fullPhone = `+${selectedCountry.dial}${cleanPhone}`;

    // البيانات اللي هتتبعت لنفس الراوت المستخدم في ModalContact:
    // name  = "No Name" (قيمة ثابتة)
    // email = رقم الهاتف الكامل (ده الـ key اللي الفورم متظبط عليه)
    const payload = {
      name:    "No Name",
      email:   fullPhone,
      country: selectedCountry.en,
      phone:   fullPhone,
    };

    try {
      setStatus("sending");

      const res = await fetch(LEAD_API_URL, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(`${res.status}`);

      setStatus("sent");
      setPhone("");
      setTimeout(() => setStatus(null), 2500);
    } catch (err) {
      console.error(err);
      setStatus("error");
      setTimeout(() => setStatus(null), 2500);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSend();
  };

  return (
    <div
      ref={wrapperRef}
      className="position-relative mx-auto mt-4"
      style={{ maxWidth: "460px", width: "100%", fontFamily: "'Cairo', sans-serif" }}
    >
      <div
        className="d-flex align-items-stretch"
        style={{
          direction:       isRTL ? "rtl" : "ltr",
          backgroundColor: "rgba(255,255,255,0.95)",
          borderRadius:    "50px",
          overflow:        "hidden",
          boxShadow:       "0 8px 30px rgba(0,0,0,0.25)",
        }}
      >
        {/* Country selector */}
        <button
          type="button"
          onClick={() => setDropdownOpen((v) => !v)}
          style={{
            display:       "flex",
            alignItems:    "center",
            gap:           "6px",
            border:        "none",
            background:    "transparent",
            padding:       "0 14px",
            fontSize:      "0.95rem",
            fontFamily:    "'Cairo', sans-serif",
            color:         "#222",
            cursor:        "pointer",
            borderInlineEnd: "1px solid #e0e0e0",
            whiteSpace:    "nowrap",
          }}
        >
          <span style={{ fontSize: "1.15rem" }}>{selectedCountry.flag}</span>
          <span>+{selectedCountry.dial}</span>
          <span style={{ fontSize: "0.7rem", opacity: 0.6 }}>▾</span>
        </button>

        {/* Phone input */}
        <input
          type="tel"
          inputMode="numeric"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t.placeholder}
          style={{
            flex:       1,
            border:     "none",
            outline:    "none",
            background: "transparent",
            padding:    "14px 10px",
            fontSize:   "0.95rem",
            fontFamily: "'Cairo', sans-serif",
            color:      "#222",
            minWidth:   0,
          }}
        />

        {/* Send button - same style/color as the "تواصل معنا" button */}
        <Button
          type="button"
          onClick={handleSend}
          disabled={status === "sending"}
          variant="contained"
          color="warning"
          sx={{
            borderRadius: 0,
            fontWeight:   700,
            fontFamily:   "'Cairo', sans-serif",
            fontSize:     "0.95rem",
            px:           2.75,
            boxShadow:    "none",
            "&:hover": {
              boxShadow: "none",
            },
          }}
        >
          {t.send}
        </Button>
      </div>

      {/* Country dropdown */}
      {dropdownOpen && (
        <div
          style={{
            position:        "absolute",
            top:              "calc(100% + 8px)",
            [isRTL ? "right" : "left"]: 0,
            width:            "260px",
            maxHeight:        "280px",
            overflowY:        "auto",
            backgroundColor:  "#fff",
            borderRadius:     "14px",
            boxShadow:        "0 10px 35px rgba(0,0,0,0.3)",
            zIndex:           20,
            direction:        isRTL ? "rtl" : "ltr",
          }}
        >
          <div style={{ padding: "8px", position: "sticky", top: 0, backgroundColor: "#fff" }}>
            <input
              autoFocus
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t.searchPh}
              style={{
                width:        "100%",
                border:       "1px solid #e0e0e0",
                borderRadius: "8px",
                padding:      "8px 10px",
                fontSize:     "0.85rem",
                fontFamily:   "'Cairo', sans-serif",
                outline:      "none",
              }}
            />
          </div>
          <div>
            {filteredCountries.length === 0 && (
              <div style={{ padding: "12px", fontSize: "0.85rem", color: "#888", textAlign: "center" }}>
                {language === "ar" ? "لا توجد نتائج" : "No results"}
              </div>
            )}
            {filteredCountries.map((c) => (
              <div
                key={c.iso}
                onClick={() => {
                  setSelectedCountry(c);
                  setDropdownOpen(false);
                  setSearch("");
                }}
                style={{
                  display:    "flex",
                  alignItems: "center",
                  gap:        "8px",
                  padding:    "9px 12px",
                  cursor:     "pointer",
                  fontSize:   "0.85rem",
                  fontFamily: "'Cairo', sans-serif",
                  backgroundColor: c.iso === selectedCountry.iso ? "#fff6e0" : "transparent",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor =
                    c.iso === selectedCountry.iso ? "#fff6e0" : "transparent")
                }
              >
                <span style={{ fontSize: "1.1rem" }}>{c.flag}</span>
                <span style={{ flex: 1 }}>{language === "ar" ? c.ar : c.en}</span>
                <span style={{ color: "#888" }}>+{c.dial}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Status message */}
      {status && (
        <div
          style={{
            marginTop:  "8px",
            fontSize:   "0.8rem",
            fontFamily: "'Cairo', sans-serif",
            color:
              status === "sent" ? "#8be08b" :
              status === "error" || status === "invalid" ? "#ff8080" : "#e0e0e0",
          }}
        >
          {status === "sending" && (language === "ar" ? "جارِ الإرسال..." : "Sending...")}
          {status === "sent"    && t.sent}
          {status === "error"   && t.error}
          {status === "invalid" && t.invalid}
        </div>
      )}
    </div>
  );
};

// ========== Hero Section ==========
const HeroSection = () => {
  const { language } = useContext(LanguageContext);

  const headingRef    = useRef(null);
  const subheadingRef = useRef(null);
  const paragraphRef  = useRef(null);
  const buttonRef     = useRef(null);
  const toastRef      = useRef(null);
  const backgroundRef = useRef(null);
  const sectionRef    = useRef(null);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;

    const resetAll = () => {
      gsap.set(backgroundRef.current, { opacity: 0, scale: 1.1 });
      gsap.set(subheadingRef.current, { opacity: 0, y: 30 });
      gsap.set(headingRef.current,    { opacity: 0, y: 50 });
      gsap.set(paragraphRef.current,  { opacity: 0, y: 30 });
      gsap.set(buttonRef.current,     { opacity: 0, scale: 0.85 });
    };

    const playAnimation = () => {
      resetAll();

      gsap.to(backgroundRef.current, {
        opacity:  1,
        scale:    1,
        duration: 1.6,
        ease:     "power2.out",
      });

      const tl = gsap.timeline({ delay: 0.2 });
      tl.to(subheadingRef.current, { opacity: 1, y: 0, duration: 0.7, ease: "power3.out" })
        .to(headingRef.current,    { opacity: 1, y: 0, duration: 1,   ease: "power3.out" }, "-=0.3")
        .to(paragraphRef.current,  { opacity: 1, y: 0, duration: 0.9, ease: "power3.out" }, "-=0.5")
        .to(buttonRef.current,     { opacity: 1, scale: 1, duration: 0.6, ease: "back.out(1.7)" }, "-=0.3");

      const isMobile = window.innerWidth <= 768;
      gsap.set(toastRef.current, isMobile ? { y: 100, opacity: 0 } : { x: 300, opacity: 0 });
      gsap.to(toastRef.current, {
        ...(isMobile ? { y: 0 } : { x: 0 }),
        opacity:  1,
        duration: 0.8,
        ease:     "power3.out",
        delay:    1.8,
      });
      setTimeout(() => {
        gsap.to(toastRef.current, {
          ...(isMobile ? { y: 100 } : { x: 300 }),
          opacity:  0,
          duration: 0.8,
          ease:     "power3.in",
        });
      }, isMobile ? 5000 : 3000);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) playAnimation();
          else resetAll();
        });
      },
      { threshold: 0.15 }
    );

    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
      gsap.killTweensOf([
        backgroundRef.current,
        subheadingRef.current,
        headingRef.current,
        paragraphRef.current,
        buttonRef.current,
        toastRef.current,
      ]);
    };
  }, [language]);

  const texts = {
    en: {
      subheading: "Sharjah's Premier Developer",
      heading:    "Masar Real Estate Projects",
      paragraph:  "Explore Masar's distinguished residential communities — from Masar 1 to Masar 3. Premium villas crafted with world-class amenities across Sharjah.",
      button:     "Explore Projects",
    },
    ar: {
      subheading: "المطور الأول في الشارقة",
      heading:    " تاون هاوس فخمه وذكيه في الشارقه في مجمع عائلي حديث ",
      paragraph: "فلل من 2-5 غرف نوم",
      button:     "تواصل معنا",
    },
  };

  const isRTL = language === "ar";

  return (
    <section
      ref={sectionRef}
      className="position-relative d-flex align-items-center justify-content-center text-center text-white"
      style={{
        minHeight:  "100svh",
        direction:  isRTL ? "rtl" : "ltr",
        fontFamily: "'Cairo', sans-serif",
        overflow:   "hidden",
      }}
    >
      {/* Background */}
      <div
        ref={backgroundRef}
        style={{
          position:           "absolute",
          inset:              0,
          backgroundImage:    `url(${image})`,
          backgroundSize:     "cover",
          backgroundPosition: "center",
          zIndex:             0,
          opacity:            0,
        }}
      />

      {/* Overlay */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{ backgroundColor: "rgba(0,0,0,0.45)", zIndex: 1 }}
      />

      {/* ✅ Falling Leaves */}
      <FallingLeaves />

      {/* Content */}
      <div
        className="position-relative px-3 px-md-4"
        style={{ maxWidth: "800px", zIndex: 4 }}
      >
        <p
          ref={subheadingRef}
          className="mb-2 text-uppercase fw-semibold"
          style={{
            fontSize:      "clamp(0.75rem, 2vw, 0.95rem)",
            letterSpacing: "0.2em",
            color:         "#ffb300",
            fontFamily:    "'Cairo', sans-serif",
            opacity:       0,
          }}
        >
          {texts[language].subheading}
        </p>

        <h1
          ref={headingRef}
          className="fw-bold mb-4"
          style={{
            fontSize:   "clamp(2rem, 5.5vw, 3.8rem)",
            lineHeight: 1.25,
            fontFamily: "'Cairo', sans-serif",
            fontWeight: 900,
            opacity:    0,
          }}
        >
          {texts[language].heading}
        </h1>

        <p
          ref={paragraphRef}
          className="mb-5 mx-auto"
          style={{
            fontSize:   "clamp(2rem, 2.5vw, 1.2rem)",
            maxWidth:   "580px",
            color:      "rgba(255,255,255,0.88)",
            lineHeight: 1.9,
            fontFamily: "'Cairo', sans-serif",
            opacity:    0,
          }}
        >
          {texts[language].paragraph}
        </p>

        <Button
          ref={buttonRef}
          variant="contained"
          color="warning"
          size="large"
          sx={{
            fontWeight:    700,
            fontFamily:    "'Cairo', sans-serif",
            fontSize:      { xs: "0.95rem", md: "1.05rem" },
            px:            { xs: 3.5, md: 5 },
            py:            { xs: 1.2, md: 1.6 },
            borderRadius:  "50px",
            letterSpacing: "0.05em",
            opacity:       0,
            "&:hover": {
              backgroundColor: "#ffb300",
              transform:       "scale(1.04)",
              boxShadow:       "0 8px 25px rgba(255,179,0,0.4)",
            },
            transition: "all 0.25s ease",
          }}
          onClick={(e) => {
            e.preventDefault();
            setShowModal(true);
          }}
        >
          {texts[language].button}
        </Button>

        {/* ✅ Phone capture input (country code + phone + send) */}
        <PhoneCaptureWidget language={language} />

        <ModalContact open={showModal} onClose={() => setShowModal(false)} />
      </div>

      {/* Toast */}
      <div
        ref={toastRef}
        style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999 }}
      />
    </section>
  );
};

export default HeroSection;